import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-66ebdf13"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "table"
};
var _hoisted_2 = {
  key: 0,
  class: "tac"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_input = _resolveComponent("el-input");

  var _component_el_table_column = _resolveComponent("el-table-column");

  var _component_el_table = _resolveComponent("el-table");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [$props.title ? (_openBlock(), _createElementBlock("h3", _hoisted_2, _toDisplayString($props.title), 1)) : _createCommentVNode("", true), _createVNode(_component_el_table, {
    data: $props.tableData,
    border: "",
    style: _normalizeStyle($props.style),
    "max-height": $data.maxheight,
    onCellClick: $options.tabClick,
    "show-header": $props.isShowHeader,
    "row-key": $options.getRowKey
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.header, function (value, key, index) {
        return _openBlock(), _createBlock(_component_el_table_column, {
          key: index,
          prop: key,
          width: key === 'idx' ? '70px' : '',
          label: value,
          align: "center"
        }, {
          default: _withCtx(function (scope) {
            return [_createElementVNode("span", {
              style: {
                "display": "none"
              },
              class: "inputSpan",
              ref_for: true,
              ref: "spanr".concat(scope.$index, "c").concat(scope.column.rawColumnKey)
            }, [_createVNode(_component_el_input, {
              modelValue: scope.row[key],
              "onUpdate:modelValue": function onUpdateModelValue($event) {
                return scope.row[key] = $event;
              },
              maxlength: "300",
              placeholder: "请输入",
              size: "small",
              onBlur: function onBlur($event) {
                return $options.inputBlur(scope.row, key);
              },
              onInput: $options.input,
              disabled: $options.isBan(scope.row[key], key),
              onKeyup: function onKeyup($event) {
                return $options.keyup($event, scope.$index, scope.column.rawColumnKey);
              },
              ref_for: true,
              ref: "r".concat(scope.$index, "c").concat(scope.column.rawColumnKey)
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur", "onInput", "disabled", "onKeyup"])], 512), _createElementVNode("span", {
              class: _normalizeClass(["content", $props.repeatList.includes(scope.row[key]) ? 'danger' : '']),
              ref_for: true,
              ref: "txtr".concat(scope.$index, "c").concat(scope.column.rawColumnKey)
            }, _toDisplayString(scope.row[key]), 3)];
          }),
          _: 2
        }, 1032, ["prop", "width", "label"]);
      }), 128))];
    }),
    _: 1
  }, 8, ["data", "style", "max-height", "onCellClick", "show-header", "row-key"])]);
}